import React, { useState } from "react";
import {
  Div,
  MediumFilledButton,
  MediumOutlineButton,
  Text2,
  Text3
} from "components/Base";
import Select from "react-select";
import StyleWrapper from "components/Global/Modal/Layout/StyleWrapper";

const BulkEditPassTypeModal = ({
  selectedOrderIds = [],
  bulkUpdatePassTypes,
  passTypes,
  loadingPassTypes,
  hideModal
}) => {
  const [fromType, setFromType] = useState(null);
  const [toType, setToType] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleUpdate = () => {
    if (!fromType?.value || !toType?.value || !selectedOrderIds.length) return;

    setLoading(true);
    bulkUpdatePassTypes({
      fromType: fromType.value,
      toType: toType.value,
      orderIds: selectedOrderIds
    });
    setLoading(false);
    hideModal();
  };

  // Filter out the selected "from" type from the "to" type options
  // Apply safety checks to make sure we have valid data
  const toTypeOptions =
    Array.isArray(passTypes) && fromType
      ? passTypes.filter(type => type && type.id !== fromType.value)
      : [];

  if (loadingPassTypes) {
    return (
      <StyleWrapper
        hideModal={hideModal}
        heading="Bulk Edit Pass Type"
        width={600}
        bodyStyles={{ padding: "12px 24px" }}
      >
        <Text3>Loading pass types...</Text3>
      </StyleWrapper>
    );
  }

  return (
    <StyleWrapper
      hideModal={hideModal}
      heading="Bulk Edit Pass Type"
      width={600}
      bodyStyles={{ padding: "12px 24px" }}
    >
      <Text3>Selected Orders ({selectedOrderIds.length || 0})</Text3>
      <Div pt={3}>
        <Text2 py={2}>Select Order Type</Text2>
        <Select
          placeholder="Select current pass type"
          options={
            Array.isArray(passTypes)
              ? passTypes.map(type => {
                  return {
                    label: type?.name || "Unknown",
                    value: type?.id || ""
                  };
                })
              : []
          }
          value={fromType}
          onChange={setFromType}
          styles={{
            menuPortal: base => ({
              ...base,
              zIndex: 9999
            })
          }}
        />
      </Div>
      <Div py={3}>
        <Text2 py={2}>Change To</Text2>
        <Select
          placeholder="Select target pass type"
          options={toTypeOptions.map(type => ({
            label: type?.name || "Unknown",
            value: type?.id || ""
          }))}
          isDisabled={!fromType}
          value={toType}
          onChange={setToType}
          menuPortalTarget={document.body}
          styles={{
            menuPortal: base => ({
              ...base,
              zIndex: 9999
            })
          }}
        />
      </Div>
      <Div display="row.center.center" pt={2}>
        <MediumOutlineButton
          mr={2}
          width={1}
          py={6}
          style={{ padding: "20px", fontWeight: "bold" }}
          onClick={hideModal}
        >
          Cancel
        </MediumOutlineButton>
        <MediumFilledButton
          bg="primary7"
          width={1}
          onClick={handleUpdate}
          disabled={
            !fromType || !toType || loading || selectedOrderIds.length === 0
          }
          py={6}
          style={{ padding: "20px", fontWeight: "bold" }}
        >
          {loading ? "Updating..." : "Update Pass Types"}
        </MediumFilledButton>
      </Div>
    </StyleWrapper>
  );
};

export default BulkEditPassTypeModal;
